import React, {useMemo} from 'react';
import {SalesforceDeal, SalesforceDealField} from 'api';
import Checkbox from './Checkbox';
import Text from './Text';
import Date from './Date';

interface Props {
  field: SalesforceDealField;
  salesforceDeal: SalesforceDeal;
}

export const FieldValue: React.FC<Props> = ({field, salesforceDeal}) => {
  const Value = useMemo(() => {
    const value = salesforceDeal.addition[`${field.fieldName}`];

    if (field.fieldType === 'checkbox') {
      return <Checkbox salesforceDeal={salesforceDeal} field={field} />;
    } else if (field.fieldType === 'address') {
      const hash = value;
      if (!hash) {
        return null;
      }
      const address = `${hash?.state}${hash?.city}${hash?.street}`;
      return <div>{address}</div>;
    } else if (field.fieldType === 'text' && field.updateable) {
      return <Text salesforceDeal={salesforceDeal} field={field} />;
    } else if (field.fieldType === 'date' && field.fieldName.endsWith('__c')) {
      return <Date salesforceDeal={salesforceDeal} field={field} />;
    } else {
      return <div>{value}</div>;
    }
  }, [field, salesforceDeal.addition]);

  return (
    <div className="flex items-center">
      <div className="w-2/5 text-sm ">{field.label}</div>
      <div className="w-3/5">{Value}</div>
    </div>
  );
};
